import { Bound } from "lib/@components/binding/Bound"
import { TwoSchedules } from "routes/schedule/compare/twoSchedules"
import { compareTwoObjects } from "routes/schedule/compare/task-header-bar"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { TaskContent } from "./task-content"

export function CompareTasks({ sourceTask, similarExtendedTask }) {
    const { schedule = {}, sourceTask: groupSourceTask, leftType = "", rightType = "" } = useBoundContext()
    const comparisonSourceTask = sourceTask ?? groupSourceTask
    const sourceTitle = groupSourceTask ? "Source Component" : schedule.title
    const sourceCode = groupSourceTask ? "" : schedule.code
    const similarTask = similarExtendedTask?.task

    return (
        <Bound>
            <TwoSchedules
                key={comparisonSourceTask?.componentRef ?? comparisonSourceTask?.taskId}
                showCopy={true}
                disabled={!similarTask}
                left={
                    <Bound
                        comparisonFunction={compareTwoObjects(similarTask, comparisonSourceTask)}
                        target={comparisonSourceTask}
                        originalTarget={similarTask}
                        task={comparisonSourceTask}
                        scheduleTitle={sourceTitle}
                        scheduleCode={sourceCode}
                        type={leftType}
                    >
                        <TaskContent />
                    </Bound>
                }
                right={
                    <Bound
                        comparisonFunction={compareTwoObjects(comparisonSourceTask, similarTask)}
                        target={similarTask}
                        originalTarget={comparisonSourceTask}
                        task={similarTask}
                        scheduleTitle={similarExtendedTask?.scheduleTitle}
                        scheduleCode={similarExtendedTask?.scheduleCode}
                        type={rightType}
                    >
                        <TaskContent />
                    </Bound>
                }
            />
        </Bound>
    )
}
